import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

export const ListItem = ({ storeName, listId, count, time }) => {
  const timeFormat = `${format(time && time.toDate(), 'MM/DD/YYYY')}`;
  return (
    <ButtonWrapper>
      <Link to={`/list/view/${listId}`}>
        <ListItemWrapper>
          <p>{storeName}</p>
          <PushLeft>
            <ItemCount>
              You need <Bold>{count || ''}</Bold> items on{' '}
              <Bold>{timeFormat || ''}</Bold>
            </ItemCount>
          </PushLeft>
          <p>></p>
        </ListItemWrapper>
      </Link>
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  a {
    text-decoration: none;
    font-weight: bold;
    color: var(--theme-secondary-color);
  }
`;

const ListItemWrapper = styled.ul`
  font-family: sans-serif;
  background-color: var(--theme-primary-color);
  max-width: 100%;
  padding: 20px;
  border-radius: 24px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    margin: 0;
    padding: 0;
    text-align: right;
  }
`;

const PushLeft = styled.div`
  margin-left: auto;
  margin-right: 20px;
`;

const ItemCount = styled.p`
  color: #7b7b7b;
`;

const Bold = styled.strong`
  color: var(--theme-secondary-color);
`;
